import React, { FC } from 'react';
import SwitchBase from '../../base/SwitchBase';
import View from '../../styled/View';
import {
  switchThumbOn,
  switchThumbOff,
  switchTrackOn,
  switchTrackOff,
} from '../../../constants/palette';
import styles from './styles';
import Link from '../Link';
import GalanoGrotesqueText from '../GalanoGrotesqueText';

export type TermsOfServiceProps = {
  isEnabled: boolean;
  text: string;
  linkText: string;
  onPress: (e: any) => void;
  toggleSwitch: (formikType: string, value: boolean) => void;
};

export const TermsOfService: FC<TermsOfServiceProps> = (props) => {
  const { isEnabled, text, linkText, onPress, toggleSwitch } = props;
  const trackColor = {
    false: switchTrackOff,
    true: switchTrackOn,
  };
  return (
    <View style={styles.container}>
      <SwitchBase
        containerStyle={styles.switchContainer}
        isEnabled={isEnabled}
        text={''}
        textStyle={styles.textStyle}
        thumbColorDisabled={switchThumbOff}
        thumbColorEnabled={switchThumbOn}
        trackColor={trackColor}
        toggleSwitch={(isEnabled) => toggleSwitch('agreedToTerms', isEnabled)}
      />
      <GalanoGrotesqueText style={styles.text}>
        {text}
        <Link
          text={linkText}
          onPress={onPress}
          textStyle={styles.linkStyle}
          containerStyle={{ justifyContent: 'left' }}
        />
      </GalanoGrotesqueText>
    </View>
  );
};

export default TermsOfService;
